<template>
    <v-container fluid class="pa-3" v-if="sessionActive">

        <v-card>

            <material-header title="Communications hub"
                             info="Automated panelist communications"
                             help="communications-hub"
                             icon="mdi-at">
                <template slot="buttons">

                    <v-tooltip color="primary" left v-if="hasPermission('view communications')">
                        <template v-slot:activator="{ on }">
                            <v-btn @click="refresh()" v-on="on" icon>
                                <v-icon>mdi-refresh</v-icon>
                            </v-btn>
                        </template>
                        <span>Reload data</span>
                    </v-tooltip>

                </template>
            </material-header>

            <v-alert v-if="!hasPermission(minPermission)"
                     class="body-2"
                     type="error"
            >
                Your user account doesn't have sufficient permissions for this feature
            </v-alert>

            <v-card-text v-if="hasPermission(minPermission)">

                <v-container fluid class="pa-0">
                    <v-row dense>

                        <v-col cols="2" offset="10">
                            <stat-box :height="115" :value="854" hint="Emails today"></stat-box>
                        </v-col>

                        <v-col cols="3">
                            <feature-box
                                    title="Welcome letter"
                                    icon="mdi-check-circle"
                                    description="Send welcome email automatically when new panelists join"
                                    :enabled="true">
                            </feature-box>
                        </v-col>


                        <v-col cols="3">
                            <feature-box
                                    title="Exit survey"
                                    icon="mdi-format-list-checks"
                                    description="When panelist decides to leave the panel send exit survey"
                                    :enabled="true">
                            </feature-box>
                        </v-col>

                        <v-col cols="3">
                            <feature-box
                                    title="Engagement"
                                    icon="mdi-alarm"
                                    description="Send automated email when panelist is no longer engaged"
                                    :enabled="true">
                            </feature-box>
                        </v-col>

                        <v-col cols="3">
                            <feature-box
                                    title="Milestone"
                                    icon="mdi-label"
                                    description="Send automated email when configurable milestone is met"
                                    :enabled="false">
                            </feature-box>
                        </v-col>

                        <v-col cols="3">
                            <feature-box
                                    title="Panel anniversary"
                                    icon="mdi-clock"
                                    description="Send automatic panel anniversary greeting"
                                    :enabled="false">
                            </feature-box>
                        </v-col>

                        <v-col cols="3">
                            <feature-box
                                    title="Birthday greeting"
                                    icon="mdi-cake"
                                    description="Send automatic birthday greetings to your panelists"
                                    :enabled="true">
                            </feature-box>
                        </v-col>

                    </v-row>
                </v-container>

            </v-card-text>
        </v-card>

    </v-container>
</template>

<script>

    import StatBox from '../../../components/UI/StatBoxNumerical';
    import Store from '../store';
    import {mapState, mapMutations, mapGetters, mapActions} from 'vuex';
    import activeSessionChecker from '../../../components/mixins/activeSessionCheckerMixin';
    import MaterialHeader from '../../../components/UI/MaterialHeader';
    import FeatureBox from '../../../components/UI/FeatureBox';

    const vuexModule = 'CommunicationHub';

    export default {

        mixins: [activeSessionChecker],

        components: {
            MaterialHeader,
            StatBox,
            FeatureBox
        },

        data() {
            return {
                minPermission: 'view communications',
                noticeAnniversaryModel: true,
                noticeBirthdayModel: true
            }
        },
        computed: {

            ...mapState(vuexModule, []),

            ...mapGetters(vuexModule, []),
        },

        methods: {
            ...mapActions(vuexModule, []),

            ...mapMutations(vuexModule, []),

            refresh() {
                Bus.$emit('flash-message', {message: 'Communications hub reloaded!'});
            }
        },

        created() {
            if (!this.$store.state[vuexModule]) {
                this.$store.registerModule(vuexModule, Store);
            }
        },

        beforeDestroy() {
            // Only unregister module if it is memory hungry
            //this.$store.unregisterModule(vuexModule);
        },
    }

</script>
